import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Injector,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { ReportWidgetDetailsFilterTableBaseDirective } from '../../../shared/report-widget-details-filter-table-base.directive';
import { BehaviorSubject } from 'rxjs';
import {
    IChecklist2ReportAttentionRequired,
    IChecklistReportAttentionRequiredData,
} from '../../../shared/fi-checklist2-report';
import { cloneDeep } from '@fi-shared/utils';
import { FiChecklist2ReportOpenChecklistsService } from '@fi-shared/checklist/fi-checklist2-report/services/fi-checklist2-report-open-checklists.service';
import { WidgetTableFilterType } from '@fi-shared/checklist/fi-checklist2-report/enums/fi-checklist2-report-type';

@Component({
    selector: 'fi-deviation-checkpoints-table-wrapper',
    templateUrl: './deviation-checkpoints-table-wrapper.component.html',
    styleUrls: ['./deviation-checkpoints-table-wrapper.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviations-checkpoints-table-wrapper' },
    standalone: false,
})
export class FiDeviationCheckpointsTableWrapperComponent
    extends ReportWidgetDetailsFilterTableBaseDirective
    implements OnInit
{
    @Output() onOpenAnswerDetails = new EventEmitter<IChecklistReportAttentionRequiredData>();
    @Output() filteredAttentionRequiredChange = new EventEmitter<IChecklist2ReportAttentionRequired[]>();

    private _filteredAttentionRequired$ = new BehaviorSubject<IChecklist2ReportAttentionRequired[]>([]);
    get filteredAttentionRequired$() {
        return this._filteredAttentionRequired$.asObservable();
    }

    constructor(
        injector: Injector,
        private fiChecklist2ReportOpenChecklistsService: FiChecklist2ReportOpenChecklistsService,
    ) {
        super(injector);
    }

    ngOnInit() {
        super.ngOnInit();

        // use initial deviations data when open deviations table
        this.setNewDeviationsSummaryData(this.reportData.getDeviationsSummary(this.reportParam.Id));
    }

    private setNewDeviationsSummaryData(attentionRequired: IChecklist2ReportAttentionRequired[]) {
        this._filteredAttentionRequired$.next(attentionRequired);
        this.filteredAttentionRequiredChange.emit(this._filteredAttentionRequired$.value);
    }

    selectedFilterItemsChanged() {
        this.onCurrentFilterChanged();

        this.fiChecklist2ReportOpenChecklistsService
            .getDeviationsSummary(this.currentFilter, this.reportData.auditMode)
            .then((data) => {
                this.setNewDeviationsSummaryData(data);
            });
    }

    openAttentionRequired(attentionRequired: IChecklist2ReportAttentionRequired) {
        this.onOpenAnswerDetails.emit({
            selectedItem: attentionRequired,
            filter: cloneDeep(this.currentFilter),
        });
    }

    protected readonly WidgetTableFilterType = WidgetTableFilterType;
}
